module.exports = __webpack_public_path__ + "img/bg-widget-group.e4ab797a.svg";